import Slider from "../components/Slider";
import ProductGrid from "../components/ProductGrid";
import ProductToolbar from "../components/ProductToolbar";
import CategoryCircleFilter from "../components/CategoryCircleFilter";
import FilterDrawer, { defaultFilters, productMatchesFilters } from "../components/FilterDrawer";
import useScrollReveal from "../hooks/useScrollReveal";
import { useShop } from "../context/ShopContext";
import { useAuth } from "../context/AuthContext";
import { useMemo, useState } from "react";

export default function HomePage() {
  const { products, loading } = useShop();
  const { isIndividual } = useAuth();
  const [sort, setSort] = useState("new");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const filtered = useMemo(() => {
    const list = products.filter((p) => productMatchesFilters(p, filters));
    return [...list].sort((a, b) => {
      if (sort === "priceAsc") return Number(a.price) - Number(b.price);
      if (sort === "priceDesc") return Number(b.price) - Number(a.price);
      return Number(b.id) - Number(a.id);
    });
  }, [products, sort, filters]);

  useScrollReveal([loading, filtered.length]);

  return (
    <>
      <Slider />
      <CategoryCircleFilter
        selected={filters.type}
        onSelect={(type) => setFilters((current) => ({ ...current, type }))}
      />
      <ProductToolbar count={filtered.length} sort={sort} setSort={setSort} onFilter={() => setDrawerOpen(true)} />
      {loading ? <section className="px-5 py-10">Ürünler yükleniyor...</section> : <ProductGrid products={filtered} showBuyNow={isIndividual} />}
      <FilterDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} filters={filters} setFilters={setFilters} resultCount={filtered.length} />
    </>
  );
}
